import { render, staticRenderFns } from "./UserInvitations.vue?vue&type=template&id=0f67faf6&scoped=true&lang=pug&"
import script from "./UserInvitations.vue?vue&type=script&lang=js&"
export * from "./UserInvitations.vue?vue&type=script&lang=js&"
import style0 from "./UserInvitations.vue?vue&type=style&index=0&id=0f67faf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f67faf6",
  null
  
)

export default component.exports